export interface IProgramSearchQuery {
  region?: number | null,
  vacSiteId?: string;
  name?: string;
  address?: string;
  classroom?: string; // Name or StateId
  created?: string;
};

export interface IProgramClassroomSearchQuery {
  programRegionId?: number | null,
  vacSiteId?: string;
  programName?: string;
  programAddress?: string;
  classroom?: string; // Name or StateId
};
